<section id ="gauge-chart-container">
  <div class="chartBox">
    <canvas #chartCanvas></canvas>
  </div>
  <div id="gauge-text-wrapper" class="flex-center">
    <div class="gauge-chart-label">
      {{chartLabel}}
    </div>
    <div class="gauge-bottom-text"  [innerHTML]="chartBottomText">
    </div>
  </div>
</section>

